import React from "react"
import ErrorIcon from "assets/icons/icon-network-error.svg"
import SuccessIcon from "assets/icons/icon-success.svg"
import UploadIcon from "assets/icons/icon-upload-file.svg"
import { translateText } from "../../../../getTranslationsMyProfileUploadDocumentation"
import "./uploadedFileBox.scss"
import { noop } from "lodash"
import PropTypes from "prop-types"


export const SUCCESS_TYPE = "success"
export const ERROR_TYPE = "error"
export const UPLOADER_TYPE = "uploader"

const getDataByType = (type) => {
    const componentDatayType = {
        [SUCCESS_TYPE]: {
            icon: SuccessIcon,
            alt: "success",
        },
        [ERROR_TYPE]: {
            icon: ErrorIcon,
            alt: "error",
        },
        [UPLOADER_TYPE]: {
            icon: UploadIcon,
            alt: "upload",
        },
    }

    return componentDatayType[type]
}
export const FileBox = ({
    type,
    errorMessage,
    children,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop,
}) => {
    const { icon, alt } = getDataByType(type)

    return (
        <div
            onDragOver={onDragOver ? onDragOver : noop}
            onDragEnter={onDragEnter ? onDragEnter : noop}
            onDragLeave={onDragLeave ? onDragLeave : noop}
            onDrop={onDrop ? onDrop : noop}
            className="file-box__container"
        >
            <div className={`file-box__container__box ${errorMessage && "error--border"}`}>
                <div className="file-box__container__box__icon">
                    <img src={icon} alt={alt} />
                </div>
                <div className="file-box__container__box__content">
                    {children}
                </div>
            </div>
            {errorMessage && errorMessage !== 'hidden' && <span className="file-box__container__hint error">{translateText(errorMessage)}</span>}
        </div>
    )
}

FileBox.propTypes = {
    type: PropTypes.string,
    errorMessage: PropTypes.string,
    children: PropTypes.object,
    onDragOver: PropTypes.func,
    onDragEnter: PropTypes.func,
    onDragLeave: PropTypes.func,
    onDrop: PropTypes.func,
}
